export default __webpack_public_path__ + "static/media/IMG_0346.016e277f.jpeg";